import React from 'react';
import style from './TermsAndConditions.module.css';
import {  useEffect, useState } from 'react';
import {  useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import Loading from '../../components/Loading/Loading.jsx';
import NoData from '../../components/NoData/NoData.jsx';

import '../../components/headersStyling.css';
import { getTerms } from '../../Api/staticPage';
import { basename} from "../../configiration/config";
import { filterLanguage } from './../../utilities/filterFunction';
import { imgResize } from './../../utilities/imageResize';



function TermsAndConditions() {

    const { t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const { pathname } = useLocation();
    const [termsAndConditions, setTermsAndConditions] = useState();
    const [termsAndConditionsImage, setTermsAndConditionsImage] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        getTerms().then(response => {
            if(response.data.status === true){
                if(response.data.data && response.data.data.image){
                    setTermsAndConditionsImage(response.data.data.image)
                }
                if(response.data.data && response.data.data.locales){
                    let locales=response.data.data.locales
                    let description=filterLanguage(locales)
                    setTermsAndConditions(description)
                }
            }
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
            console.log(error.response)
        });
         // eslint-disable-next-line
    }, []);
    return (
        <div>
            {/* START OF HEADER SECTION */}
                <div className={`${style.contactHeader} myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: termsAndConditionsImage && `url(${imgResize(termsAndConditionsImage,1920,455)})`}}>
                    <div className={`${style.headerContent} myHeaderContent`}>
                        <h1>{t('terms')}</h1>
                        <p>
                            <Link to={`${basename}/`} className='homeWord'>
                                {t('home')}
                            </Link>
                             / {t('terms')}
                        </p>
                    </div>
                </div>
            {/* END OF HEADER SECTION */}
            <div className="smallcomponentContainer">
                { termsAndConditions && (
                    <div className={`${style.myCustomContainer}`}>
                        <div className={`${style.termsAndConditions}`}>
                           {termsAndConditions[0].description !== null && parse(termsAndConditions[0].description) }
                        </div>
                    </div>
                )}
    
                { loading && (
                    <Loading width='100px' height='100px' />
                )}
    
                { !loading && !termsAndConditions &&
                    <NoData text='No available data' />
                }
</div>
        </div>
    )
}

export default TermsAndConditions